// removed by extract-text-webpack-plugin
module.exports = {"checkbox":"src-components-Checkbox----styles-module---checkbox---2zcaN","borderStyle":"src-components-Checkbox----styles-module---borderStyle---3pbin","checked":"src-components-Checkbox----styles-module---checked---2XmlY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Checkbox/styles.module.css
// module id = 618
// module chunks = 168707334958949